import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './OnemliTarihler.css';

function OnemliTarihler() {
  const takvim = [
    { etkinlik: "Bildiri Kabulüne Başlama", tarih: "8 Şubat 2026" },
    { etkinlik: "Bildiri Gönderimi Son Tarih", tarih: "15 Nisan 2026" },
    { etkinlik: "Kongre Kayıt İşlemleri", tarih: "8 Şubat - 10 Mayıs 2026" },
    { etkinlik: "Kabul Edilen Bildirilerin İlanı", tarih: "5 Mayıs 2026" },
    { etkinlik: "Kongre Programının İlanı", tarih: "10 Mayıs 2026" },
    { etkinlik: "Çalıştay", tarih: "20 Mayıs 2026" },
    { etkinlik: "Kongre Tarihi", tarih: "21-22 Mayıs 2026" },
    { etkinlik: "Kabul Edilen Bildirilerin Güncellenmesi", tarih: "1 Temmuz 2026" },
    { etkinlik: "Kongre Bildiri Kitabının Yayınlanması", tarih: "31 Temmuz 2026" }
  ];

  return (
    <div className="inner-page">
      <Navbar />
      
      <header className="page-hero">
        <div className="container">
          <h2>ÖNEMLİ TARİHLER</h2>
          <p>34. Ulusal Yönetim ve Organizasyon Kongresi Takvimi</p>
        </div>
      </header>

      <main className="content-container">
        {/* TAKVİM TABLOSU */}
        <div className="calendar-card">
          <table className="calendar-table">
            <thead>
              <tr>
                <th>Etkinlik / Süreç</th>
                <th className="text-right">Tarih</th>
              </tr>
            </thead>
            <tbody>
              {takvim.map((item, index) => (
                <tr key={index}>
                  <td>{item.etkinlik}</td>
                  <td className="text-right date-col">{item.tarih}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* ÖNEMLİ NOTLAR */}
        <div className="info-notes">
          <div className="note-item">
            <i className="fas fa-info-circle"></i>
            <p>Bildiri son gönderim tarihi, genişletilmiş bildiri özetleri için geçerlidir.</p>
          </div>
          <div className="note-item">
            <i className="fas fa-language"></i>
            <p>Kongremizin sunum dili, <strong>Türkçe</strong>'dir.</p>
          </div>
          <div className="note-item warning">
            <i className="fas fa-users"></i>
            <p>
              Kongremiz, <strong>yüz yüze oturumlarla</strong> gerçekleştirilecektir. 
              Uzaktan (çevrimiçi) katılım seçeneği sunulmamaktadır. 
              Bu konuda gösterilecek anlayış için teşekkür ederiz.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default OnemliTarihler;